import React, { useEffect, useState } from 'react'
import AudioPlayer from 'react-audio-player'
import styles from './AudioPlayer.module.scss'
import ReportBug from '../Reporting/ReportBug'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/store'

interface AudioPlayerProps {
  audioPath: string
  currentLanguage: string
  onNextRound: () => void
}

interface Data {
  filename: string
  current_language: string
}

const CustomAudioPlayer: React.FC<AudioPlayerProps> = ({
  currentLanguage,
  onNextRound,
}) => {
  const audioPath = useSelector(
    (state: RootState) => state.currentRound.audioPath
  )
  const [file, setFile] = useState<string | null>(null)

  useEffect(() => {
    const file = localStorage.getItem(audioPath)
    setFile(file)
  }, [audioPath])

  const data: Data = {
    filename: audioPath,
    current_language: currentLanguage,
  }

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <p>Click to listen the language</p>
      </div>
      {/* TODO: Add spinner */}
      {!file && <p>Loading audio...</p>}
      {file && <AudioPlayer src={file} controls title="Language clip" />}
      <ReportBug
        text="Report buggy audio"
        data={data}
        mode="audio_error"
        onNextRound={onNextRound}
      />
    </div>
  )
}

export default CustomAudioPlayer
